import $ from 'jquery';

import Action from "../classes/Action";

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from '../classes/Validation';
import Vars from "../../vars";

class Feed {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content : $(),
        $create  : $(),
        $edit    : $(),
        $modal   : $(),
        $form    : $()
    };

    _const = {
        entities : 'feeds',
        entity   : 'feed',
        id       : 'feed_id',
        title : {
            add  : 'Добавление нового фида',
            edit : 'Редактирование фида'
        }
    };

    _args = {
        mode   : '',
        prefix : '',
        suffix : ''
    };

    _state = {
        modal      : {},
        fields     : {},
        item       : {},
        items      : {}
    };

    _utils = {
        validation : {}
    };

    _actions = {
        activate : {
            title: 'Активация фида'
        },
        deactivate : {
            title: 'Деактивация фида'
        },
        remove : {
            title: 'Удаление фида'
        },
        confirmation : {
            title: 'этот фид'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Фиды',
                            href  : '#feeds'
                        },
                        {
                            title : 'Фид №' + self._state.item.feed_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.feed_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Фиды',
                            href  : '#feeds'
                        },
                        {
                            title : 'Фид №' + self._state.item.feed_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.feed_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode   = args.mode;
        self._args.title  = args.title;
        self._args.prefix = args.prefix;
        self._args.suffix = args.suffix;
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _initModal = () => {
        let self = this;

        self._setFields();

        loader.increase();

        let queue = [];
        if (Object.keys(self._state.item).length) {
            queue.push({
                path : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item[self._const.id]: self._args.prefix + '_' + self._args.suffix)
            });
        }
        queue.push({
            path : '/api/' + self._const.entities + '/options'
        });

        Request.send({
            queue : queue,
            done : function(response, extraResponse) {
                loader.decrease();

                self._state.item = Object.keys(self._state.item).length ? response[self._const.entity] : {};

                const options    = Object.keys(self._state.item).length ? extraResponse.options : response.options;
                const objects    = Object.keys(options).length && options.objects ? options.objects : [];

                if (!Object.keys(objects).length) {
                    new Modal({
                        title: 'Сообщение',
                        content: Utils.renderProfileTemplate('warning', {
                            warning : {
                                text : 'Для выполнения операции необходимо добавить хотя бы один комплекс'
                            }
                        }),
                        confirm : function(args) {
                            args.modal && args.modal.trigger('close');
                        }
                    });

                    return;
                }

                self._elems.$modal = new Modal({
                    title : self._state.item ? self._const.title.edit : self._const.title.add,
                    closingConfirmation : true,
                    confirm : function(args){
                        self._bindSubmit(args);
                    },
                    content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                        [self._const.entity] : Object.keys(self._state.item).length ? self._state.item : null,
                        fields               : self._state.fields,

                        options              : options,
                        ad_types             : response.ad_types,
                        buildings            : response.buildings,
                        building_ids         : response.building_ids,
                        sections             : response.sections,
                        section_ids          : response.section_ids,
                        section_show_ids     : response.section_show_ids,
                        object_ids           : response.object_ids,

                        buttons  : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    })
                });
                
                self._elems.$form = self._elems.$modal.find('form');

                self._setValidation();
                self._bindObjectActions();
                self._bindObjectAddAction(options);

                self._elems.$form.find('.checklist-feed-images').each(function(){
                    $(this).find('.checklist-item__checklist .checklist-item').on('click', function(){
                        if (!$(this).hasClass('checked')) {
                            if ($(this).prev()) {
                                $(this).prev().removeClass('checked');
                                $(this).prev().children('.checklist-item__input').prop('disabled', true);
                            }
                            if ($(this).next()) {
                                $(this).next().removeClass('checked');
                                $(this).next().children('.checklist-item__input').prop('disabled', true);
                            }
                        }
                    })
                });
            }
        });
    };

    _bindObjectActions = () => {
        let self = this;

        let $form = self._elems.$modal.find('form');

        $form.find('select[name="feed[feed_type]"]').change(function() {
            let $option = $(this).children(':selected');

            $form.find('.add-section-id.--object').each(function(){
                $(this).hide();
                $(this).children().removeClass('active').hide();
                $(this).find('input').attr('disabled', 'disabled');
            });
            $form.find('.add-section-id.--building').each(function(){
                $(this).hide();
                $(this).children().removeClass('active').hide();
                $(this).find('input').attr('disabled', 'disabled');
            });

            $form.find('.add-section-id-popper[data-entity="object"]').hide();
            $form.find('.add-section-id-popper[data-entity="building"]').hide();
            $form.find('.add-section-id-popper[data-entity="section"]').hide();

            $form.find('.form-field[data-name="feed-buildings"] .add-section-id').removeClass('active').hide();
            $form.find('.form-field[data-name="feed-buildings"] .add-section-id div').hide();
            $form.find('.form-field[data-name="feed-buildings"]').removeClass('avito yandex_realty yandex_newbuildings domclick');
            $form.find('.form-field[data-name="feed-buildings"] .add-section-id input').attr('disabled', 'disabled');

            if ($option.length && $option.val() != '') {
                const name = $option.data('name');

                if ($form.find('.add-section-id.--object .' + name).length) {
                    $form.find('.add-section-id.--object .' + name).each(function(){
                        $(this).parent().show();
                        $(this).show();
                        if ($(this).children('input').val() != '') {
                            $(this).addClass('active');
                            $(this).children('input').removeAttr('disabled');
                        }
                    });

                    $form.find('.add-section-id-popper[data-entity="object"].' + name).show();
                }

                $form.find('.form-field[data-name="feed-buildings"]').addClass(name);
                $form.find('.form-field[data-name="feed-buildings"] .add-section-id').css('display', 'inline-block');
                $form.find('.form-field[data-name="feed-buildings"] .add-section-id .' + name).show();

                $form.find('.form-field[data-name="feed-buildings"] .add-section-id .' + name).each(function(){
                    if ($(this).find('input').val() != '') {
                        $(this).parent().addClass('active');
                        $(this).find('input').removeAttr('disabled');
                    }
                    else {
                        $(this).parent().removeClass('active');
                        $(this).find('span').show();
                        $(this).find('input').attr('disabled', 'disabled');
                    }
                });

                if (name == 'yandex_newbuildings') {
                    $form.find('.form-field[data-name="feed-adtypes"]').hide();
                }
                else {
                    $form.find('.form-field[data-name="feed-adtypes"]').show();
                }

                $form.find('.form-field[data-name="object_ids"]').children('.add-section-id-popper').hide();

                if (name == 'domclick') {
                    $form.find('.checklist .add-section-id-popper[data-entity="building"]').show();
                }
                else {
                    $form.find('.checklist .add-section-id-popper[data-entity="section"]').show();
                }

                if (name == 'yandex_realty' || name == 'yandex_newbuildings' || name == 'domclick') {
                    $form.find('.add-section-id-popper[data-entity="object"].' + name).each(function(){
                        if ($(this).parent('.form-field').find('[name="feed[object_ids][]"]').val()) {
                            $(this).show();
                            $(this).parent().children('.add-section-id').children().hide();
                            $(this).parent().children('.add-section-id').children('.' + name).show();
                            $(this).parent().children('.add-section-id').show();

                            if ($(this).parent().children('.add-section-id').children('.' + name).find('input').val() != '') {
                                $(this).parent().children('.add-section-id').children('.' + name).find('input').removeAttr('disabled');
                                $(this).parent().children('.add-section-id').children('.' + name).addClass('active');
                            }
                        }
                    });
                }
                else {
                    $form.find('.add-section-id-popper[data-entity="object"]').each(function(){
                        $(this).hide();
                        $(this).parent().children('.add-section-id').hide();

                        if ($(this).parent().children('.add-section-id').find('input').val() != '') {
                            $(this).parent().children('.add-section-id').find('input').attr('disabled', 'disabled');
                            $(this).parent().children('.add-section-id').removeClass('active');
                        }
                    });
                }
            }
            else {
                $form.find('.add-section-id-popper').each(function(){
                    $(this).hide();
                    $(this).prev('.add-section-id').hide();
                    $(this).prev('.add-section-id').removeClass('active');
                    $(this).prev('.add-section-id').find('input').attr('disabled', 'disabled');
                });

                $form.find('.form-field[data-name="feed-adtypes"]').hide();
            }
        });

        $form.find('select[name="feed[feed_type]"]').trigger('change');

        $form.find('select[name="feed[object_ids][]"]').change(function(){
            let $select = $(this);

            let $parent = $select.parents('.form-field');
            $parent.removeClass('error');
            $parent.find('.form-field__message').addClass('hidden').html('');

            const val = parseInt($select.val());
            if (isNaN(val)) return;

            let $feedTypeOption = $form.find('select[name="feed[feed_type]"]').children(':selected');

            let $option = $(this).children(':selected');

            if ($feedTypeOption.length && $feedTypeOption.val() != '') {
                let $addSectionPopper = $(this).parents('.form-field').find('.add-section-id-popper');

                const name = $feedTypeOption.data('name');

                $addSectionPopper.each(function(){
                    if (($(this).data('entity') == 'object' && (name == 'yandex_realty' || name == 'yandex_newbuildings' || name == 'domclick')) || $(this).data('entity') != 'object') {
                        let $addSectionId = $(this).parent().children('.add-section-id');
                        $addSectionId.children().hide();
                        $addSectionId.children('.' + name).show();

                        $(this).show();
                        $addSectionId.show();

                        if ($(this).data('entity') == 'object') {
                            let attrName = ['yandex_realty', 'yandex_newbuildings'].indexOf(name) != -1 ? 'yandex_realty' : name;

                            $addSectionId.children('.' + name).children('input').attr('name', 'object_' + attrName + '_' + $option.val() + '_id');
                            if ($option.data(attrName) != undefined) {
                                $addSectionId.addClass('active');
                                $addSectionId.find('input').val($option.data(attrName)).removeAttr('disabled');
                            }
                            else {
                                $addSectionId.removeClass('active');
                                $addSectionId.find('span').removeAttr('style');
                                $addSectionId.find('input').val('').attr('disabled', 'disabled').removeAttr('style');
                            }
                        }
                    }
                });
            }
            else {
                $form.find('.add-section-id-popper').each(function(){
                    $(this).hide();
                    $(this).prev('.add-section-id').hide();
                    $(this).prev('.add-section-id').find('input').attr('disabled', 'disabled');
                });
            }

            let $wrapper = $select.parents('.form-field__wrapper');
            $parent.removeClass('error');
            $parent.find('.form-field__message').addClass('hidden').html('');
            $wrapper.find('.form-field[data-name="feed-buildings"]').hide();
            $wrapper.find('.form-field[data-name="feed-adtypes"]').hide();
            let flag1, flag2, flag3 = false;
            $wrapper.find('.form-field[data-name="feed-buildings"] > ul').each(function(){
                let $ul = $(this);

                $ul.find('.add-section-id').each(function(){
                    $(this).removeClass('active');
                    $(this).find('input').attr('disabled', 'disabled');
                });

                $ul.removeClass('active').hide();
                $ul.find('[data-name="feed[building_all]"]').each(function(){
                    $(this).attr('disabled', 'disabled');
                    $(this).parent().removeClass('checked');
                });
                $ul.find('input[name="object[building_ids][]"], input[name="object[section_ids][]"]').each(function(){
                    $(this).attr('disabled', 'disabled');
                    $(this).parent().removeClass('checked');

                    if($(this).next('.add-section-id').length){
                        let $addSectionId = $(this).next('.add-section-id');
                        const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');

                        $addSectionId.find('.' + name).removeClass('active');
                        $addSectionId.find('.' + name + ' input').attr('disabled', 'disabled');
                    }
                });
                if (parseInt($ul.data('complex-id')) == val && $(this).children('ul > li').length){
                    $ul.find('.add-section-id').each(function(){
                        if (!$(this).hasClass('active') && $feedTypeOption.length && $feedTypeOption.val() != '') {
                            $(this).find('.' + $feedTypeOption.val() + ' input').removeAttr('disabled');
                        }
                    });

                    $wrapper.find('.form-field[data-name="feed-buildings"]').show();

                    if ($feedTypeOption.length && $feedTypeOption.val() != '') {
                        const name = $feedTypeOption.data('name');

                        if (name == 'yandex_newbuildings') {
                            $form.find('.form-field[data-name="feed-adtypes"]').hide();
                        }
                        else {
                            $form.find('.form-field[data-name="feed-adtypes"]').show();
                        }
                    }

                    $wrapper.find('.form-field[data-name="feed-adtypes"] input[data-name="feed[types][]"]').each(function(){
                        $(this).attr('name', 'feed' + val + '[types][]');
                    });
                    $wrapper.find('.form-field[data-name="feed-buildings"] input[data-name="feed[auto_adding_new]"]').each(function(){
                        $(this).attr('name', 'feed' + val + '[auto_adding_new]');
                    });
                    $wrapper.find('.form-field[data-name="feed-buildings"] .checklist[data-complex-id="' + val + '"] input[data-name="feed[building_all]"]').each(function(){
                        $(this).attr('name', 'feed' + val + '[building_all]');
                    });
                    $wrapper.find('.form-field[data-name="feed-adtypes"] input[data-name="feed[ad_types][]"]').each(function(){
                        $(this).attr('name', 'feed' + val + '[ad_types][]');
                    });

                    $ul.addClass('active').show();
                    $ul.find('input[name="object[building_ids][]"], input[name="object[section_ids][]"]').each(function(){
                        let $input = $(this);
                        if(!$(this).parent().hasClass('disabled')) {
                            $(this).removeAttr('disabled');
                            $(this).parent().addClass('checked');

                            if ($(this).next('.add-section-id').length){
                                let $addSectionId = $(this).next('.add-section-id');
                                const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');
                                if ($addSectionId.find('.' + name + ' input').val() != ''){
                                    $addSectionId.addClass('active');
                                    $addSectionId.find('.' + name + ' input').removeAttr('disabled');
                                }
                                else {
                                    $addSectionId.removeClass('active');
                                    $addSectionId.find('.' + name + ' input').attr('disabled', 'disabled');
                                }
                            }
                        }
                        if($(this).parent().children('ul') !== undefined && $(this).parent().children('ul').length){
                            let $subUl = $input.parent().children('ul');
                            if ($subUl.find('input[name="object[section_ids][]"]').length == $subUl.children('li.disabled').length) {
                                $subUl.parent().removeClass('checked').addClass('disabled');
                                $input.attr('disabled', 'disabled');
                            }
                            else
                                flag3 = true;
                        }
                    });

                    if($ul.find('input[name="object[building_ids][]"]').length == $ul.children('li.disabled').length)
                        flag2 = true;

                    flag1 = true;
                }
            });

            let objects = [];
            $form.find('select[name="feed[object_ids][]"]').each(function(){
                let $sel = $(this);
                const value = $sel.val();
                let $par = $sel.parents('.form-field');
                if(objects.indexOf(value) != -1){
                    $par.addClass('error');
                    $par.find('.form-field__message').removeClass('hidden').html('Нельзя выбрать один и тот же комплекс дважды. Выберите, пожалуйста, другой');
                }
                objects[value] = value;
            });

            if($select.children('option[value="' + val  + '"]').data('active') == 0){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('Выбранный комплекс неактивен. Выберите другой комплекс или <a' +
                    ' href="/profile#objects/' + val + '"' +
                    ' target="_blank">активируйте его</a>')
            }
            else if(!flag1 || flag2){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('В выбранном комплексе отсутствуют дома c активными секциями. Выберите другой комплекс или <a' +
                    ' href="/profile#objects/' + val + '"' +
                    ' target="_blank">активируйте дома и секции</a>')
            }
            else if(!flag3){
                $parent.addClass('error');
                $parent.find('.form-field__message').removeClass('hidden').html('Отсутствуют активные секции. Чтобы выбрать дом, необходимо <a target="_blank">активировать секции</a>')
            }

            if ($parent.hasClass('error')) {
                $parent.find('.form-field__message').show();
            }

            $form.find('select[name="feed[feed_type]"]').trigger('change');
        });

        $form.find('[data-object-id]').each(function() {
            $(this).find('select[name="feed[object_ids][]"]').each(function() {
                let $select = $(this);
                const val = parseInt($select.val());
                if (isNaN(val)) return;

                let $feedTypeOption = $form.find('select[name="feed[feed_type]"]').children(':selected');

                let $option = $(this).children(':selected');

                if ($feedTypeOption.length && $feedTypeOption.val() != '') {
                    const name = $feedTypeOption.data('name');
                    let $addSectionPopper = $(this).parents('.form-field').find('.add-section-id-popper.' + name);

                    $addSectionPopper.each(function () {
                        if (($(this).data('entity') == 'object' && ['yandex_realty', 'domclick'].indexOf(name) != -1) || $(this).data('entity') != 'object') {
                            let $addSectionId = $(this).parent().children('.add-section-id');

                            $(this).show()
                            $addSectionId.show();

                            if ($(this).data('entity') == 'object') {
                                $addSectionId.find('.' + name + ' input').attr('name', 'object_' + name + '_' + $option.val() + '_id');
                                if ($option.data(name) != undefined) {
                                    $addSectionId.find('.' + name + ' input').val($option.data(name));
                                } else {
                                    $addSectionId.removeClass('active');
                                    $addSectionId.find('.' + name + ' input').val('').attr('disabled', 'disabled');
                                }
                            }
                        }
                    });
                } else {
                    $form.find('.add-section-id-popper').each(function () {
                        $(this).hide();
                        $(this).prev('.add-section-id').hide();
                        $(this).prev('.add-section-id').find('input').attr('disabled', 'disabled');
                    });
                }

                let $wrapper = $select.parents('.form-field__wrapper');

                $wrapper.find('.form-field[data-name="feed-buildings"] > ul').each(function(){
                    let $ul = $(this);

                    $ul.find('.add-section-id').each(function(){
                        $(this).removeClass('active');
                        $(this).find('input').attr('disabled', 'disabled');
                    });

                    $ul.find('input[name="object[building_ids][]"], input[name="object[section_ids][]"]').each(function(){
                        if($(this).next('.add-section-id').length){
                            let $addSectionId = $(this).next('.add-section-id');
                            const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');

                            $addSectionId.find('.' + name).removeClass('active');
                            $addSectionId.find('.' + name + ' input').attr('disabled', 'disabled');
                        }
                    });
                    if (parseInt($ul.data('complex-id')) == val && $(this).children('ul > li').length){
                        $ul.find('.add-section-id').each(function(){
                            if (!$(this).hasClass('active') && $feedTypeOption.length && $feedTypeOption.val() != '') {
                                $(this).find('.' + $feedTypeOption.val() + ' input').removeAttr('disabled');
                            }
                        });

                        $ul.find('input[name="object[building_ids][]"], input[name="object[section_ids][]"]').each(function(){
                            if(!$(this).parent().hasClass('disabled')) {
                                if ($(this).next('.add-section-id').length){
                                    let $addSectionId = $(this).next('.add-section-id');
                                    const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');
                                    if ($addSectionId.find('.' + name + ' input').val() != ''){
                                        $addSectionId.addClass('active');
                                        $addSectionId.find('.' + name + ' input').removeAttr('disabled');
                                    }
                                    else {
                                        $addSectionId.removeClass('active');
                                        $addSectionId.find('.' + name + ' input').attr('disabled', 'disabled');
                                    }
                                }
                            }
                        });
                    }
                });
            });
        });

        $('.js-profile-feed-object-delete').unbind('click').on('click', function(e) {
            e.preventDefault();
            let $link = $(this);

            let $parent = $link.parents('.form-field__wrapper');
            let $select = $parent.find('select[name="feed[object_ids][]"]');

            const val = parseInt($select.val());

            $parent.remove();
            $('.js-profile-feed-object-add').show();

            return false;
        });

        $('.add-section-id span').unbind('click').on('click', function(e) {
            $(this).parents('.add-section-id').addClass('active');

            const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');

            $(this).parents('.add-section-id').find('.' + name + ' input').removeAttr('disabled').focus();

            return false;
        });

        $('.add-section-id input').unbind('click').on('click', function(e) {
            e.stopPropagation();
        });

        $('.js-add-building-id-popper').unbind('click').on('click', function(){
            const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');

            let template = '';

            if ($(this).data('entity') != '' && name != 'avito') {
                template = name + '-' + $(this).data('entity')
            }
            else {
                template = name;
            }

            new Modal({
                title   : 'Информация',
                content : Utils.renderProfileTemplate('feed-' + template + '-information'),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                }
            });

            return false;
        });

        $('.js-add-section-id-popper').unbind('click').on('click', function(){
            const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');

            let template = '';

            if ($(this).data('entity') != '' && name != 'avito') {
                template = name + '-' + $(this).data('entity')
            }
            else {
                template = name;
            }

            new Modal({
                title   : 'Информация',
                content : Utils.renderProfileTemplate('feed-' + template + '-information'),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                }
            });

            return false;
        });
    };

    _bindObjectAddAction = (options) => {
        let self = this;

        let $form = self._elems.$modal.find('form');

        $form.find('.form-field__wrapper:first').addClass('first');

        let $btnObjectAdd    = $form.find('.js-profile-feed-object-add');
        const objShowedCount = $form.find('.form-field__wrapper').length;
        const objCount       = $form.find('.form-field__wrapper.first select[name="feed[object_ids][]"] option').length - 1;

        if(objCount === objShowedCount) $btnObjectAdd.hide();

        $btnObjectAdd.click(function(e){
            e.preventDefault();
            let $btn = $(this);

            $btn.before(
                Utils.renderProfileTemplate('feed-object', {
                    feed:             null,
                    options:          options
                })
            );

            self._bindObjectActions();

            if ($form.find('select[name="feed[feed_type]"]').val() != null){
                const name = $form.find('select[name="feed[feed_type]"]').children(':selected').data('name');
                $form.find('.form-field[data-name="feed-buildings"]').removeClass('avito');
                $form.find('.form-field[data-name="feed-buildings"]').addClass(name);
            }

            const objShowedCount = $form.find('.form-field__wrapper').length;
            if (objCount === objShowedCount) $btn.hide();
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        const errors = $form.find('.form-field.error').length;

        if(errors) return;

        loader.increase();

        Request.send({
            path   : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item[self._const.id] + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                $modal.trigger('close');

                if(self._args.mode === Vars.view.index || self._args.mode === Vars.view.list) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.feed_id;
                }
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create = self._elems.$content.find('.js-profile-feed-create');
        self._elems.$edit   = self._elems.$content.find('.js-profile-feed-edit');
    };

    _bindActions = () => {
        let self = this;

        new Action({
            id       : self._state.item.feed_id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _bindCreateMax = () => {
        let self = this;

        const count = parseInt(self._elems.$create.data('count'));
        const max   = parseInt(self._elems.$create.data('max'));

        if (count < max && max != 0) return true;

        if (max == 0) {
            new Modal({
                title: ifacade.constants.messages.feeds.access.max.title,
                content: Utils.renderProfileTemplate('info', {
                    message : ifacade.constants.messages.feeds.access.start.message,
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Тарифы',
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                    window.location.href = '#tariffs';
                }
            });

            return false;
        }

        new Modal({
            title: ifacade.constants.messages.feeds.access.max.title,
            content: Utils.renderProfileTemplate('info', {
                message : ifacade.constants.messages.feeds.access.max.message.replace('%max%', max),
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Хорошо'
                    },
                    two : null
                }
            }),
            confirm : function(args) {
                args.modal && args.modal.trigger('close');
            }
        });

        return false;
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();
            if (!self._bindCreateMax()) return;

            self._initModal();
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initModal();
        });

        self._bindActions();
    };

    _index = () => {
        let self = this;
        self._bindElements();
        self._bindUI();
    };

    _list = () => {
        let self = this;

        self._bindElements();

        Request.send({
            queue: [
                {
                    path: '/api/' + self._const.entities
                },
                {
                    path: '/api/counts?only=objects'
                },
                {
                    path: '/api/accesses?only=' + self._const.entities
                }
            ],
            done: function(response, extra_response, extraResponse1) {
                loader.decrease();
                Utils.scrollToTop();

                const accesses      = extraResponse1.accesses;

                self._state.items   = response[self._const.entities] ? response[self._const.entities] : {};
                const counts        = extra_response.counts ? extra_response.counts : [];
                const objects       = Object.keys(counts).length && counts.objects ? counts.objects : 0;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items,
                    objects                : objects,
                    accesses               : accesses
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        self._bindElements();

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.prefix + '_' + self._args.suffix,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                if (response.error) {
                    window.location.href = '/profile#' + self._const.entities;
                    return;
                }

                self._state.item     = response[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Фиды',
                            href  : '#feeds'
                        },
                        {
                            title : 'Фид №' + self._state.item.feed_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.feed_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        if (self._args.mode === Vars.view.index) {
            self._index();
        } else if (self._args.mode === Vars.view.list) {
            self._list();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        }
    };
}

export default Feed;